import { useSearchFieldState } from "@react-stately/searchfield";
import { useSearchField } from "@react-aria/searchfield";
import { useProviderProps } from "@react-spectrum/provider";
import { TextFieldBase } from "@react-spectrum/textfield";
import _react, { forwardRef, useRef } from "react";
import _spectrumIconsUiMagnifier from "@spectrum-icons/ui/Magnifier";
import { ClearButton } from "@react-spectrum/button";
import { classNames, useSlotProps } from "@react-spectrum/utils";
import _babelRuntimeHelpersEsmObjectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
import _babelRuntimeHelpersEsmExtends from "@babel/runtime/helpers/esm/extends";
import "./main.css";

function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

// ASSET: /Users/govett/dev/react-spectrum-v3/node_modules/@adobe/spectrum-css-temp/components/search/vars.css
var $f7ba17202ccc7135cfe7128957b$exports = {};
$f7ba17202ccc7135cfe7128957b$exports = {
  "spectrum-Search": "_spectrum-Search_d08c7",
  "spectrum-ClearButton": "_spectrum-ClearButton_d08c7",
  "is-quiet": "_is-quiet_d08c7",
  "spectrum-Search-input": "_spectrum-Search-input_d08c7",
  "spectrum-Search--invalid": "_spectrum-Search--invalid_d08c7",
  "spectrum-Search--valid": "_spectrum-Search--valid_d08c7",
  "spectrum-Search--loadable": "_spectrum-Search--loadable_d08c7",
  "spectrum-Search-circleLoader": "_spectrum-Search-circleLoader_d08c7",
  "spectrum-Search-validationIcon": "_spectrum-Search-validationIcon_d08c7",
  "spectrum-Textfield": "_spectrum-Textfield_d08c7"
};
var $f7ba17202ccc7135cfe7128957b$$interop$default = $parcel$interopDefault($f7ba17202ccc7135cfe7128957b$exports);

function $e97dfb3c8186c575d74a940bc4c22$var$SearchField(props, ref) {
  props = useSlotProps(props, 'searchfield');
  props = useProviderProps(props);

  let defaultIcon = /*#__PURE__*/_react.createElement(_spectrumIconsUiMagnifier, null);

  let {
    icon = defaultIcon,
    isDisabled,
    UNSAFE_className
  } = props,
      otherProps = _babelRuntimeHelpersEsmObjectWithoutPropertiesLoose(props, ["icon", "isDisabled", "UNSAFE_className"]);

  let state = useSearchFieldState(props);
  let inputRef = useRef();
  let {
    labelProps,
    inputProps,
    clearButtonProps,
    descriptionProps,
    errorMessageProps
  } = useSearchField(props, state, inputRef);

  let clearButton = /*#__PURE__*/_react.createElement(ClearButton, _babelRuntimeHelpersEsmExtends({}, clearButtonProps, {
    preventFocus: true,
    UNSAFE_className: classNames($f7ba17202ccc7135cfe7128957b$$interop$default, 'spectrum-ClearButton'),
    isDisabled: isDisabled
  }));

  return /*#__PURE__*/_react.createElement(TextFieldBase, _babelRuntimeHelpersEsmExtends({}, otherProps, {
    labelProps: labelProps,
    inputProps: inputProps,
    descriptionProps: descriptionProps,
    errorMessageProps: errorMessageProps,
    UNSAFE_className: classNames($f7ba17202ccc7135cfe7128957b$$interop$default, 'spectrum-Search', 'spectrum-Textfield', {
      'is-disabled': isDisabled,
      'is-quiet': props.isQuiet,
      'spectrum-Search--invalid': props.validationState === 'invalid',
      'spectrum-Search--valid': props.validationState === 'valid'
    }, UNSAFE_className),
    inputClassName: classNames($f7ba17202ccc7135cfe7128957b$$interop$default, 'spectrum-Search-input'),
    ref: ref,
    inputRef: inputRef,
    isDisabled: isDisabled,
    icon: icon,
    wrapperChildren: state.value !== '' && !props.isReadOnly && clearButton
  }));
}
/**
 * A SearchField is a text field designed for searches.
 */


export let SearchField = /*#__PURE__*/forwardRef($e97dfb3c8186c575d74a940bc4c22$var$SearchField);
//# sourceMappingURL=module.js.map
